module.exports = __webpack_public_path__ + "img/792063d.jpg";